import React from 'react'
import { Message, Button, Icon } from 'semantic-ui-react'
import { NotificationState } from '../../hooks/useNotification'

interface Props {
  notification: NotificationState
  onDismiss: (id: string) => void
}

const ToastNotification: React.FC<Props> = ({ notification, onDismiss }) => {
  const { options } = notification
  
  const getIconName = () => {
    switch (options.type) {
      case 'success':
        return 'check circle'
      case 'error':
        return 'exclamation triangle'
      case 'warning':
        return 'warning circle'
      case 'info':
        return 'info circle'
      default:
        return 'info circle'
    }
  }

  const getColor = () => {
    switch (options.type) {
      case 'success':
        return 'green'
      case 'error':
        return 'red'
      case 'warning':
        return 'yellow'
      case 'info':
        return 'blue'
      default:
        return 'blue'
    }
  }

  return (
    <div
      data-testid={`${options.type}-notification`}
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        maxWidth: '400px',
        transform: notification.isVisible ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.3s ease-in-out',
        opacity: notification.isVisible ? 1 : 0
      }}
    >
      <Message
        color={getColor()}
        onDismiss={() => onDismiss(notification.id)}
        style={{
          margin: 0,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          borderRadius: '8px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <Icon 
            name={getIconName() as any} 
            size='large'
            style={{ marginTop: '2px', flexShrink: 0 }}
          />
          
          <div style={{ flex: 1 }}>
            <Message.Header style={{ marginBottom: '4px' }}>
              {options.title}
            </Message.Header>
            
            <div style={{ fontSize: '14px', lineHeight: '1.4' }}>
              {options.message}
            </div>

            {options.actions && options.actions.length > 0 && (
              <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                {options.actions.map((action, index) => (
                  <Button
                    key={index}
                    size='small'
                    primary={action.primary}
                    basic={!action.primary}
                    onClick={() => {
                      action.action()
                      onDismiss(notification.id)
                    }}
                    style={{
                      fontSize: '12px',
                      padding: '6px 12px',
                      height: 'auto'
                    }}
                  >
                    {action.label}
                  </Button>
                ))}
              </div>
            )}
          </div>
        </div>
      </Message>
    </div>
  )
}

export default ToastNotification 